import React, { Component } from 'react';

export class NoTenantRegistration extends Component {
  displayName = NoTenantRegistration.name

  render() {
    return (
      <div>
        <div className="ms-font-xxl ms-fontWeight-semibold">Setup!</div>
        <p>Welcome to MeetingMapRoom - easily find your meeting room</p>
        <p>To get you started, you need an Office365 tenant administrator to initialy set up the app:</p>
        <ul>
          <li><strong>Step 1</strong>. Enroll you company by clicking this link: <a target="_blank" rel="noopener noreferrer" href="https://www.meetingroommap.net/Account/SignUp">https://www.meetingroommap.net/SignUp</a>. </li>
          <li><strong>Step 2</strong>. Log in as tenant administrator and consent to the application.</li>
          <li><strong>Step 3</strong>. (optional). In Azure AD the tenant administrator can assign the "MeetingMapEditor" role to users. Editors will be able to delete maps and room locations (see details here: <a target="_blank" rel="noopener noreferrer" href="https://www.meetingroommap.net/home/setup">https://www.meetingroommap.net/home/setup</a>).</li>
          <li><strong>Step 4</strong>. Now any user can upload maps and assign rooms to maps (click the settings icon below or go to <a target="_blank" rel="noopener noreferrer" href="https://www.meetingroommap.net">https://www.meetingroommap.net</a> and login).</li>
        </ul>
      </div>
    );
  }
}
